import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const bDActivitiesApi = createApi({
  reducerPath: 'bDActivitiesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Blocking-Domains-Activity'],
  endpoints: (builder) => ({
    getBlockingDomainActivities: builder.query({
      query: (params) => ({
        url: `/blocking_domain/activities/`,
        params,
      }),
      providesTags: ['Blocking-Domains-Activity'],
    }),

    createBlockingDomainActivity: builder.mutation({
      query: (body) => ({
        url: '/blocking_domain/activities/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Blocking-Domains-Activity'],
    }),

    getBlockingDomainActivityById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/blocking_domain/activities/${id}/`,
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Blocking-Domains-Activity', id }],
    }),

    updateBlockingDomainActivityById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/blocking_domain/activities/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Blocking-Domains-Activity'],
    }),
    

    deleteBlockingDomainActivityById: builder.mutation({
      query: (id) => ({
        url: `/blocking_domain/activities/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Blocking-Domains-Activity'],
    }),

    
  }),
});

export const {
  useGetBlockingDomainActivitiesQuery,
  useLazyGetBlockingDomainActivitiesQuery,
  useCreateBlockingDomainActivityMutation,
  useGetBlockingDomainActivityByIdQuery,
  useUpdateBlockingDomainActivityByIdMutation,
  useDeleteBlockingDomainActivityByIdMutation,
} = bDActivitiesApi;
